import types from "../actions/types";

export default (state = null, action) => {
  if (action.type == types.OFFLINE) {
    return !!action.offline;
  }
  return state;
};
